<template>
  <div class="slider" :class="{finalFilter: this.finalFilter}">
    <div class="border">
      <vue-slider
        v-model="value"
        v-bind="options"
        :value="value"
        :tooltip-formatter="formatTooltip"
        v-on:change="getSelectedValuesWhithDebounce"
        ref="slider"
        class="range-slider-price"
      ></vue-slider>
    </div>
    <div class="prices" :class="{pricesFinalFilter: this.finalFilter}">
      <span
        >De R${{
          min.toLocaleString("pt-BR", { minimumFractionDigits: 0 })
        }}</span
      >
      <span
        >Até R${{
          max.toLocaleString("pt-BR", { minimumFractionDigits: 0 })
        }}</span
      >
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component"; // https://nightcatsama.github.io/vue-slider-component/#/

export default {
  name: "RangeSlider",
  components: {
    VueSlider,
  },
  watch: {
    min(newMinValue){
      
      if(this.finalFilter){
        this.options = {
          min: newMinValue,
          max: this.max,
        };

        this.$nextTick(() => {
          this.$refs.slider.setValue(this.max)
        });
      }
    },
    max(newMaxValue){
      
      if(this.finalFilter){
        this.options = {
          min: this.min,
          max: newMaxValue,
        };
        
        this.$nextTick(() => {
          this.$refs.slider.setValue(newMaxValue)
        });
      }
    },
  },
  props: ["sendAnalytics", "min", "max", "finalFilter"],
  data() {
    return {
      value: [this.max],
      selectedValues: [],
      formatTooltip: (value) =>
        `R$ ${
          "" + value.toLocaleString("pt-BR", { minimumFractionDigits: 0 })
        }`,

      options: {
        min: this.min,
        max: this.max,
      },
    };
  },
  computed: {},
  mounted() {
   
    const vueSliderProgress = document.querySelector('.range-slider-price .vue-slider-process');
    vueSliderProgress.classList.add('vue-slider-custom-animation');

    const vueSliderDot = document.querySelector('.range-slider-price .vue-slider-dot:last-child');
    vueSliderDot.classList.add('vue-slider-dot-custom-animation');

    const divborder = document.querySelector("div.border")
    divborder.classList.add("overlayBorder")

    setTimeout(() => {
      divborder.classList.remove("overlayBorder")
    }, 3500);
  },
  methods: {
    getSelectedValuesWhithDebounce(){
      return this.debounce(() => this.getSelectedValues())
    },
    debounce(callback, timeout = 500){
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(callback, timeout);
    },
    getSelectedValues() {
      window.dataLayer.push({
        event: "gtm.preco",
        target: "gtm-more",
        action: "click",
        preco: `${this.value},00`,
        // label: "target-properties",
        // value: 5000,
        // noninteraction: "interaction-type",
        // TransactionID: numRandomicoUnico,
      });

      const eventName = this.finalFilter ? 'selectPriceFinalFilter' : 'selectPrice';
      
      this.$emit(eventName, this.value);
    },
  },
};
</script>

<style lang="scss">
@import "../sass/ranger-slider.mixin.scss";
@include vue-slider-component-styles;

.slider {
  .border {
    width: 700px;
    background-color: #97bde0;
    background: linear-gradient(
      to right,
      #f9e29d 0%,
      #c5ddb5 50.31%,
      #97bde0 100%
    );
    padding: 15px 25px;
    border-radius: 160px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  .prices {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    font-weight: bold;

    span:first-child {
      margin-left: 25px;
    }

    span:last-child {
      margin-right: 25px;
    }
  }

  .pricesFinalFilter{
    font-family: $font-family-default-bold;
    font-size: 1.3rem;
  }

  @media (max-width: 520px){
    .pricesFinalFilter{
      font-size: 0.875rem;
    }
  }
}

.vue-slider-custom-animation {
  transition-timing-function: ease-in;
  animation: MarksMove 3s;
}

.vue-slider-dot-custom-animation {
  transition-timing-function: ease-in;
  animation: dotAnimation 3s;
}

@media (min-width: 768px) and (max-width: 990px) {
  .slider {
    .border {
      width: 500px;
    }
  }
}

@media (max-width: $bp-mobile) {
  .slider {
    margin: 0 auto;
    box-sizing: border-box;
    
    .border {
      max-width: 90vw;
      // border-radius: 0;
    }
  }
}

@media (max-width: 325px) {
  .slider {
    .border {
      max-width: 100vw;
      border-radius: 0;
    }
  }
}
</style>
